import { ExportPageData } from "components/ExportPageData";
import { FilterTags } from "components/FilterTags";
import { LockedFrag } from "components/Fragments/ComponentsFrag";
import { PageRequestError } from "components/PageRequestError";
import StatusBarIcons from "components/StatusBardIcons";
import { Title } from "components/Title";
import useApp from "hooks/useApp";
import useListPage from "hooks/useListPage";
import useModulePermissions from "hooks/useModulePermissions";
import useUtils from "hooks/useUtils";
import ProdutosAddPage from "pages/produtos/Add";
import ProdutosEditPage from "pages/produtos/Edit";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { Paginator } from "primereact/paginator";
import { ProgressSpinner } from "primereact/progressspinner";
import { SplitButton } from "primereact/splitbutton";
import { useState } from "react";
import MasterDetailPages from "./MasterDetailPages";
import ProdutoGheDialog from "./ProdutoGheDialog";

const Produtos = (props) => {
    const app = useApp();
    const utils = useUtils();
    const { empid, setempid } = useApp();
    const { permissions, error } = useModulePermissions(props.pageName);

    // Estado para controle do modal GHE
    const [gheModalState, setGheModalState] = useState({
        visible: false,
        product: null
    });

    const handleOpenGheModal = (product) => {
        setGheModalState({
            visible: true,
            product
        });
    };

    const handleCloseGheModal = () => {
        setGheModalState({
            visible: false,
            product: null
        });
    };

    const filterSchema = {
        search: {
            tagTitle: "Search",
            value: "",
            valueType: "single",
            options: [],
        },
    };

    const statusIcons = [
        { icon: 'pi pi-lock', color: 'yellow', hint: 'Bloqueado' },
        { icon: 'pi pi-lock-open', color: 'white', hint: 'Liberado' },
        { icon: 'pi pi-cloud-download', color: 'yellow', hint: 'Importado / Integrador' },
        { icon: 'pi pi-file-edit', color: 'white', hint: 'Digitação Manual' }
    ];

    const pageController = useListPage(props, filterSchema);
    const filterController = pageController.filterController;
    const {
        records,
        pageReady,
        loading,
        selectedItems,
        apiUrl,
        sortBy,
        sortOrder,
        apiRequestError,
        setSelectedItems,
        getPageBreadCrumbs,
        onSort,
        deleteItem,
        pagination,
    } = pageController;
    const { filters, setFilterValue } = filterController;
    const {
        totalRecords,
        totalPages,
        recordsPosition,
        firstRow,
        limit,
        onPageChange,
    } = pagination;

    function ActionButton(data) {
        const items = [
            {
                label: "Editar",
                command: () => {
                    app.openPageDialog(
                        <ProdutosEditPage
                            isSubPage
                            apiPath={`/produtos/edit/${data.id}`}
                        />,
                        { closeBtn: true }
                    );
                },
                icon: "pi pi-pencil",
                visible: permissions?.up,
            },
            {
                label: "Excluir",
                command: () => {
                    deleteItem(data.id);
                },
                icon: "pi pi-trash",
                visible: permissions?.de,
            },
        ];

        return (
            <div className="flex align-items-center justify-content-end gap-2">
                <Button
                    type="button"
                    label="GHE"
                    icon="pi pi-shield"
                    className="p-button-sm p-button-outlined p-button-info font-bold"
                    tooltip="Visualizar GDE / GHE"
                    tooltipOptions={{ position: "top" }}
                    onClick={() => handleOpenGheModal(data)}
                />
                <SplitButton
                    dropdownIcon="pi pi-bars"
                    className="dropdown-only p-button-text p-button-plain"
                    model={items}
                />
            </div>
        );
    }

    function CustoTemplate(data) {
        if (data) {
            return <>{app.FmtCurrChip({ value: data.venda })}</>;
        }
    }

    function IntegracaoTemplate(data) {
        if (data) {
            return (
                <div style={{ textAlign: 'center' }}>
                    {data.integracao === true ? (
                        <i className="pi pi-file-edit" style={{ color: 'white', fontSize: '1.5em' }} title="Digitação Manual"></i>
                    ) : (
                        <i className="pi pi-cloud-download" style={{ color: 'yellow', fontSize: '1.5em' }} title="Importado / Integrador"></i>
                    )}
                </div>
            );
        }
    }

    function EstoqueTemplate(data) {
        if (data) {
            return <>{app.FmtQtdChip({ value: data.estoque })}</>;
        }
    }

    function EstoqueLocalTemplate(data) {
        if (data) {
            return <>{app.FmtQtdChip({ value: data.estoquelocal })}</>;
        }
    }

    function IdTemplate(data) {
        if (data) {
            return <>{data.grupos_id}</>;
        }
    }

    function EmpidTemplate(data) {
        if (data) {
            return <>{data.grupos_empid}</>;
        }
    }

    function NomeTemplate(data) {
        if (data) {
            return <>{data.grupos_nome}</>;
        }
    }

    const OnClickFichaProd = (param) => {
        if (param) {
            var paramns = { id: 4, filter: `produtos|id|${param.id}|0|0` };
            app.openPageDialog(<app.PrintPreview paramns={paramns} />, {
                maximized: true,
                closeBtn: true,
                width: "80vw",
            });
        }
    };

    function TemplateFichaProd(data) {
        if (data) {
            return <app.PrintButton onClick={() => OnClickFichaProd(data)} />;
        }
    }

    function MasterDetailBtnTemplate(data) {
        if (data) {
            return (
                <Button
                    className="p-button-text"
                    onClick={() =>
                        app.openPageDialog(
                            <MasterDetailPages masterRecord={data} />,
                            { closeBtn: true }
                        )
                    }
                    label=""
                    icon="pi pi-caret-down"
                />
            );
        }
    }

    function PageLoading() {
        if (loading) {
            return (
                <div className="flex align-items-center justify-content-center text-gray-500 p-3">
                    <ProgressSpinner style={{ width: "50px", height: "50px" }} />
                    <div className="font-bold text-lg ml-2">Carregando...</div>
                </div>
            );
        }
    }

    function EmptyRecordMessage() {
        if (pageReady && !records.length) {
            return (
                <div className="text-lg mt-3 p-3 text-center text-400 font-bold">
                    Nenhum Registro Encontrado
                </div>
            );
        }
    }

    function MultiDelete() {
        if (selectedItems.length) {
            return (
                <div className="m-2 flex-grow-0">
                    <Button
                        onClick={() => deleteItem(selectedItems)}
                        icon="pi pi-trash"
                        className="p-button-danger"
                        title="Excluir selecionado"
                    />
                </div>
            );
        }
    }

    function ExportData() {
        if (props.exportData && records.length) {
            const downloadFileName = `${utils.dateNow()}-produtos`;
            return (
                <div className="m-2">
                    <ExportPageData
                        csv={false}
                        pageUrl={apiUrl}
                        downloadFileName={downloadFileName}
                        butonLabel="Exportar"
                        tooltip="Exportar"
                        buttonIcon="pi pi-print"
                    />
                </div>
            );
        }
    }

    function PagerControl() {
        if (props.paginate && totalPages > 1) {
            const pagerReportTemplate = {
                layout: pagination.layout,
                CurrentPageReport: (options) => {
                    return (
                        <span className="text-sm text-gray-500 px-2">
                            Registros{" "}
                            <b>
                                {recordsPosition} do {options.totalRecords}
                            </b>
                        </span>
                    );
                },
            };
            return (
                <div className="flex-grow-1">
                    <Paginator
                        first={firstRow}
                        rows={limit}
                        totalRecords={totalRecords}
                        onPageChange={onPageChange}
                        template={pagerReportTemplate}
                    />
                </div>
            );
        }
    }

    function PageActionButtons() {
        return (
            <div className="flex flex-wrap">
                <MultiDelete />
                <ExportData />
            </div>
        );
    }

    function PageFooter() {
        if (pageReady && props.showFooter) {
            return (
                <div className="flex flex-wrap align-items-center mt-3">
                    <PageActionButtons />
                    <PagerControl />
                </div>
            );
        }
    }

    function PageBreadcrumbs() {
        if (props.showBreadcrumbs) {
            const items = getPageBreadCrumbs();
            return (
                items.length > 0 && (
                    <BreadCrumb className="mb-3" model={items} />
                )
            );
        }
    }

    if (apiRequestError) {
        return <PageRequestError error={apiRequestError} />;
    }

    return (
        <main id="ProdutosListPage" className="main-page">
            {props.showHeader && (
                <section className="page-section mb-3">
                    <div className="container-fluid">
                        <div className="grid justify-content-between align-items-center">
                            <div className="col">
                                <Title
                                    title="Produtos"
                                    titleClass="text-2xl text-primary font-bold"
                                    subTitleClass="text-500"
                                    separator={false}
                                />
                            </div>
                            {app.auth.user.prodcad && (
                                <div className="col-fixed">
                                    <Button
                                        label="Adicionar novo"
                                        icon="pi pi-plus"
                                        onClick={() =>
                                            app.openPageDialog(
                                                <ProdutosAddPage
                                                    isSubPage
                                                    apiPath={`/produtos/add`}
                                                />,
                                                { closeBtn: true }
                                            )
                                        }
                                        className="p-button w-full bg-primary"
                                        visible={permissions?.cr}
                                    />
                                </div>
                            )}

                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left w-full">
                                    <i className="pi pi-search" />
                                    <InputText
                                        placeholder="Pesquisa"
                                        className="w-full"
                                        value={filters.search.value}
                                        onChange={(e) =>
                                            setFilterValue(
                                                "search",
                                                e.target.value.toUpperCase()
                                            )
                                        }
                                    />
                                </span>
                            </div>
                        </div>
                    </div>
                </section>
            )}

            <section className="page-section">
                <div className="container-fluid">
                    <div className="grid">
                        <div className="col comp-grid">
                            <FilterTags filterController={filterController} />
                            <div>
                                <PageBreadcrumbs />
                                <StatusBarIcons title={"LEGENDA"} icons={statusIcons} />
                                <div className="page-records">
                                    <DataTable
                                        lazy={true}
                                        loading={loading}
                                        selectionMode="checkbox"
                                        selection={selectedItems}
                                        onSelectionChange={(e) =>
                                            setSelectedItems(e.value)
                                        }
                                        value={records}
                                        dataKey="id"
                                        sortField={sortBy}
                                        sortOrder={sortOrder}
                                        onSort={onSort}
                                        className="p-datatable-sm"
                                        stripedRows={true}
                                        showGridlines={false}
                                        rowHover={true}
                                        responsiveLayout="scroll"
                                        emptyMessage={<EmptyRecordMessage />}
                                    >
                                        <Column
                                            style={{ minWidth: "85px", width: "85px" }}
                                            field="codexterno"
                                            header="COD"
                                            sortable={true}
                                        />
                                        <Column
                                            style={{ minWidth: "85px", width: "85px" }}
                                            field="codfabrica"
                                            header="FAB"
                                            sortable={true}
                                        />
                                        <Column
                                            style={{ minWidth: "65px", width: "65px", textAlign: "center" }}
                                            headerStyle={{ textAlign: "center" }}
                                            field="unidade"
                                            header="UND"
                                            sortable={true}
                                        />
                                        <Column
                                            style={{ minWidth: "220px" }}
                                            field="nome"
                                            header="Nome"
                                            sortable={true}
                                        />
                                        <Column
                                            style={{ minWidth: "110px", width: "110px", textAlign: "right" }}
                                            headerStyle={{ textAlign: "right" }}
                                            field="venda"
                                            header="Venda"
                                            body={CustoTemplate}
                                            sortable={true}
                                        />
                                        <Column
                                            style={{ minWidth: "95px", width: "95px", textAlign: "center" }}
                                            headerStyle={{ textAlign: "center" }}
                                            field="estoque"
                                            header="Estoque"
                                            body={EstoqueTemplate}
                                            sortable={true}
                                        />
                                        <Column
                                            style={{ minWidth: "120px", width: "120px", textAlign: "center" }}
                                            headerStyle={{ textAlign: "center" }}
                                            field="estoquelocal"
                                            header="Estoque Cliente"
                                            body={EstoqueLocalTemplate}
                                            sortable={true}
                                        />
                                        <Column
                                            style={{ minWidth: "50px", width: "50px", textAlign: "center" }}
                                            headerStyle={{ textAlign: "center" }}
                                            field="active"
                                            body={(e) => LockedFrag(e.active)}
                                        />
                                        <Column
                                            style={{ minWidth: "50px", width: "50px", textAlign: "center" }}
                                            headerStyle={{ textAlign: "center" }}
                                            field="integracao"
                                            body={IntegracaoTemplate}
                                        />
                                        <Column
                                            style={{ minWidth: "160px", width: "160px" }}
                                            header="Ações"
                                            headerClass="text-center"
                                            body={ActionButton}
                                        />
                                    </DataTable>
                                </div>
                                <PageFooter />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Modal GDE / GHE */}
            {gheModalState.visible && (
                <ProdutoGheDialog
                    visible={gheModalState.visible}
                    onHide={handleCloseGheModal}
                    product={gheModalState.product}
                />
            )}
        </main>
    );
};

Produtos.defaultProps = {
    primaryKey: "id",
    pageName: "produtos",
    apiPath: "produtos/index",
    routeName: "produtoslist",
    msgBeforeDelete: "Tem certeza de que deseja excluir este registro?",
    msgTitle: "Apagar registro",
    msgAfterDelete: "Registro excluído com sucesso",
    showHeader: true,
    showFooter: true,
    paginate: true,
    isSubPage: false,
    showBreadcrumbs: true,
    exportData: true,
    importData: false,
    keepRecords: false,
    multiCheckbox: true,
    search: "",
    fieldName: "empid",
    fieldValue: null,
    sortField: "",
    sortDir: "",
    pageNo: 1,
    limit: 10
};

export default Produtos;
